// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__400w-solar-panel_productcontent__Mix_2"};